import { useAppSelector } from './useAppSelector';

export default function useCanModifyEmbargoKeyword() {
  const user = useAppSelector((state) => state.user);
  return !!user.group?.modifyEmbargoKeyword;
}
